import {
  APIDatetime,
  APIuuid,
  IAPIArrayData,
  IAPIData,
  IAPIDataObject,
  IAPIRelationship
} from '@shared/interfaces/api.interface';
import { IComment } from '@shared/interfaces/comment.interface';
import { IRecruiter } from '@shared/interfaces/recruiter.interface';
import { Recruiter } from '@shared/models/recruiter.model';

export class Comment implements IComment {
  public static readonly TYPE: string = String('Comment');

  public id: APIuuid;
  public content: string;
  public created_at: APIDatetime;
  public updated_at: APIDatetime;
  public is_active: boolean;
  public author_full_name: string;

  public author: IRecruiter;
  public identifiable_type: string;
  public identifiable_id: APIuuid;

  constructor(partial: Partial<IComment>) {
    Object.assign(this, partial);
  }

  public get apiData(): IAPIData {
    return {
      data: {
        type: Comment.TYPE,
        id: this.id,
        attributes: {
          content: this.content
        },
        relationships: {
          identifiable: {
            type: this.identifiable_type,
            id: this.identifiable_id
          } as IAPIRelationship
        }
      }
    } as IAPIData;
  }

  public static fromAPI(res: IAPIData): IComment {
    const data = res.data;
    const included = res.included;

    if (!(data && data.type === Comment.TYPE)) {
      throw new Error(`There was a problem parsing ${Comment.TYPE} API data`);
    }

    const comment = new Comment({
      id: data.id,
      ...data.attributes
    });

    const relationships = data.relationships as any;

    if (included && relationships?.author) {
      const authorData = included.find(
        (i: IAPIDataObject) =>
          i.id === (relationships.author as IAPIRelationship).id
      );

      if (authorData) {
        comment.author = Recruiter.fromAPI({ data: authorData, included });
      }
    }

    if (relationships?.identifiable) {
      comment.identifiable_type = (
        relationships.identifiable as IAPIRelationship
      ).type;
      comment.identifiable_id = (
        relationships.identifiable as IAPIRelationship
      ).id;
    }

    return comment;
  }

  public static fromAPIArray(res: IAPIArrayData): IComment[] {
    const dataArray = res.data || [];
    const included = res.included;

    return dataArray.map((data: IAPIDataObject) => {
      if (!(data && data.type === Comment.TYPE)) {
        throw new Error(`There was a problem parsing ${Comment.TYPE} API data`);
      }

      const comment = new Comment({
        id: data.id,
        ...data.attributes
      });

      const relationships = data.relationships as any;

      if (included && relationships?.author) {
        const authorData = included.find(
          (i: IAPIDataObject) =>
            i.id === (relationships.author as IAPIRelationship).id
        );

        if (authorData) {
          comment.author = Recruiter.fromAPI({ data: authorData, included });
        }
      }

      if (relationships?.identifiable) {
        comment.identifiable_type = (
          relationships.identifiable as IAPIRelationship
        ).type;
        comment.identifiable_id = (
          relationships.identifiable as IAPIRelationship
        ).id;
      }

      return comment;
    });
  }
}
